/**
 * The session's voice against the live catalogue (services/voiceCatalogue.server `getVoiceRoster`,
 * passed down by the session loader): its default, and a stored choice the catalogue no longer
 * offers (Failures spec, case 28).
 */
import type {VoiceOption} from '@product/quies/data/voiceRoster'

export type VoiceRoster = Record<string, VoiceOption[]>

export function voicesFor(roster: VoiceRoster, language: string | null): VoiceOption[] {
    return language ? roster[language] ?? [] : []
}

export function defaultVoiceId(roster: VoiceRoster, language: string | null): string | null {
    return voicesFor(roster, language)[0]?.voiceId ?? null
}

/** A stored voice still offered stays; one no longer offered gives way to the language's default,
 *  and `changed` says so. A language the catalogue has no voice for keeps what was stored. */
export function resolveStoredVoice(
    roster: VoiceRoster,
    language: string | null,
    stored: string | null,
): {voiceId: string | null; changed: boolean} {
    const voices = voicesFor(roster, language)
    if (!stored) return {voiceId: defaultVoiceId(roster, language), changed: false}
    if (voices.length === 0 || voices.some((v) => v.voiceId === stored)) return {voiceId: stored, changed: false}
    return {voiceId: voices[0].voiceId, changed: true}
}
